import { useEffect, useState } from 'react';

import useClaimsCommodityCodeList from '../../../redux/hooks/useClaimsCommodityCodeList';
import FormSelectBox from '../Inputs/FormSelectBox';

const ClaimsCommodityCodeSelector = ({
  label = 'Commodity Code',
  placeholder = 'Enter Commodity Code',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const [options, setOptions] = useState([]);
  const commodityCodeList = useClaimsCommodityCodeList();

  useEffect(() => {
    if (commodityCodeList?.length >= 0) {
      const options = commodityCodeList.map((row) => ({
        label: row.commodityCode,
        value: row.commodityCodeKey,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [commodityCodeList]);

  return (
    <FormSelectBox
      loading={commodityCodeList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default ClaimsCommodityCodeSelector;
